import { render, staticRenderFns } from "./ResultsPost.vue?vue&type=template&id=7e123a28"
import script from "./ResultsPost.vue?vue&type=script&lang=js"
export * from "./ResultsPost.vue?vue&type=script&lang=js"
import style0 from "./ResultsPost.vue?vue&type=style&index=0&id=7e123a28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports